import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    padding: 0,
    margin: 0,
    fontFamily: "Lato",
    background:
      "transparent linear-gradient(119deg, #00152E 0%, #02489D 100%) 0% 0% no-repeat padding-box",
    [theme.breakpoints.only("xs")]: {
      color: "#FFFFFF",
      background: "#02489D 0% 0% no-repeat padding-box",
    },
  },
  main: {
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "#FFFFFF",
    "& .mainContent": {
      background: "#02489D 0% 0% no-repeat padding-box",
      padding: "50px",
      borderRadius: "18px",
      [theme.breakpoints.only("xs")]: {
        width: "100%",
        padding: "39px 25px 32px 25px",
        borderRadius: 0,
        minHeight: "100vh",
        maxWidth: 380,
      },
      "& .logoSec": {
        marginBottom: "50px",
        "& .logo": {
          width: "312px",
        },
      },
      "& .loader": {
        color: "white",
        marginTop: 20,
      },
      "& .mainSec": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",

        "& .title": {
          fontSize: "21px",
          color: "#FFFFFF",
          marginBottom: "26px",
          //opacity: '0.93',
        },
        "& .formSec": {
          background: "#002B60 0% 0% no-repeat padding-box",
          borderRadius: "10px",
          padding: "17px 9px",
          "& .formLabel": {
            fontSize: "16px",
            color: "#FFFFFF",
            marginBottom: "18px",
            //opacity: '0.93',
          },
          "& .formField": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            "& .codeInput": {
              height: "41px",
              width: "30px",
              [theme.breakpoints.only("xs")]: {
                width: "100%",
                maxWidth: "30px",
              },
              background: "#FFFFFF 0% 0% no-repeat padding-box",
              borderRadius: "6px",
              marginInline: 3,
              "& input": {
                fontSize: "24px",
                fontWeight: "bold",
                [theme.breakpoints.only("xs")]: {
                  fontSize: "23px",
                },
                color: "#002B60",
                padding: "6px 0px !important",
                margin: 0,
                textAlign: "center",
                opacity: "0.93",
              },
            },
            "& .codeDivider": {
              fontSize: "24px",
              color: "#FFFFFF",
              textAlign: "center",
              opacity: "0.93",
            },
          },
        },
        "& .activateSec": {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "23px",
          "& .activatedBox": {
            width: "100%",
            height: "107px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            background: "#71D092 0% 0% no-repeat padding-box",
            borderRadius: "10px",
            "& svg.icon": {
              fontSize: "50px",
              fill: "#002B60",
            },
            "& .content": {
              color: "#002B60",
              textAlign: "left",
              opacity: "0.93",
              "& .line1": {
                fontSize: "23px",
                fontWeight: 700,
              },
              "& .line2": {
                font: "normal normal normal 16px/18px Lato",
                fontSize: "16px",
              },
            },
          },
          "& .actionBtn": {
            width: "100%",
            height: "60px",
            font: "normal normal normal 16px/18px Lato",
            color: "#FFFFFF",
            border: "1px solid #FFFFFF",
            borderRadius: "16px",
            opacity: "0.93",
          },
        },
      },
    },
  },
}));
